module.exports = __webpack_public_path__ + "img/xls.2a6c5e07.svg";